import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import history from "../utils/history";
//Importing components
import Home from "../containers/Home";
import Register from "../containers/Register";
import Login from "../components/Login/Login";
import ResetPassword from "../components/ResetPassword/ResetPassword";
import LayoutComponent from "../containers/MainLayout";
import PageNotFound from "../components/PageNotFound/PageNotFound";
import PageAccessDenied from "../components/PageAccessDenied/PageAccessDenied";
import Permissions from "../utils/PermissionKeys.json"

const CreateRoutes = () => (
  <Router history={history} basename={process.env.PUBLIC_URL}>
    <Switch>
      <Route
        path="/dashboard"
        exact
        render={() => <Redirect to="/app/dashboard" />}
      />
      {/* <PermissionRoute
        keyObj={Permissions.VIEW_AUDIT_TRAILS}
        path="/audittrail"
        exact
        render={() => <Redirect to="/app/audittrail" />}
      />
      <PermissionRoute
        keyObj={Permissions.VIEW_STATEMENT}
        path="/statements"
        exact
        render={() => <Redirect to="/app/statements" />}
      /> */}
      <Route
        keyObj={Permissions.VIEW_SYSTEM_USERS}
        path="/users"
        exact
        render={() => <Redirect to="/app/users" />}
      />
      <Route
        keyObj={Permissions.VIEW_CONTACTS_LIST}
        path="/contacts"
        exact
        render={() => <Redirect to="/app/contacts" />}
      />
      <Route
        path="/app"
        exact
        render={() => <Redirect to="/app/dashboard" />}
      />
      <Route
        path="/userrolelist"
        exact
        render={() => <Redirect to="/app/userrolelist" />}
      />
      <Route
        path="/procedureslist"
        exact
        render={() => <Redirect to="/app/procedureslist" />}
      />
      <Route
        keyObj={Permissions.VIEW_INVENTORY}
        path="/inventorylist"
        exact
        render={() => <Redirect to="/app/inventorylist" />}
      />
      <Route
        keyObj={Permissions.TRACK_INVENTORY}
        path="/inventorysummery"
        exact
        render={() => <Redirect to="/app/inventorysummery" />}
      />
      <Route
        path="/subcategorieslist"
        exact
        render={() => <Redirect to="/app/subcategorieslist" />}
      />
      <Route
        path="/roomlist"
        exact
        render={() => <Redirect to="/app/roomlist" />}
      />
      <Route
        path="/appoinmentlist"
        exact
        render={() => <Redirect to="/app/appoinmentlist" />}
      />
      <Route
        path="/pendingapprovallist"
        exact
        render={() => <Redirect to="/app/pendingapprovallist" />}
      />
      <Route
        path="/paymenthistory"
        exact
        render={() => <Redirect to="/app/paymenthistory" />}
      />
      <Route
        path="/parties-delete-entries"
        exact
        render={() => <Redirect to="/app/parties-delete-entries" />}
      />
      <Route
        keyObj={Permissions.CONDUCT_APPOINTMENT}
        path="/conductappoinment"
        exact
        render={() => <Redirect to="/app/conductappoinment" />}
      />
      <Route
        keyObj={Permissions.VIEW_INVOICE}
        path="/invoicelist"
        exact
        render={() => <Redirect to="/app/invoicelist" />}
      />
      <Route path="/app" component={LayoutComponent} />
      <Route path="/" exact component={Login} />
      <Route path="/login" exact component={Login} />
      <Route path="/resetpassword" exact component={ResetPassword} />
      <Route path="/register" exact component={Register} />
      <Route path="/home" exact component={Home} />
      <Route path="/access-denied" exact component={PageAccessDenied} />
      <Route path="*" exact component={PageNotFound} />
    </Switch>
  </Router>
);

export default CreateRoutes;
